/**
 * London marketplace stats (searchProperties: contractType=coliving, propertyLocation=London).
 * Update after major UK scraper runs — round listings down for stable SEO copy.
 *
 * Last verified: 2026-11-04 — 3,062 active listings (API live count), 26+ operators
 */
module.exports = {
  listingsCount: 3000,
  listingsLabel: '3,000+',
  operatorsCount: 26,
  operatorsLabel: '26',
};
